import style from './FieldVersionCard.module.scss';

import { FixedIcon } from '@components/Icon';
import { DateFormat, DateHelper } from '@utils/DateHelper';

export interface FieldVersionCardProps {
    updateTime: string;
}

interface Props extends FieldVersionCardProps {
    value: string;
    isHtml: boolean;
    author: string;
    updateTime: string;
    isSigned: boolean;
    onRestoreClick(): void;
}

export function FieldVersionCard({ isSigned, value, isHtml, author, updateTime, onRestoreClick }: Props) {
    return (
        <div className={style.root}>
            <div className={style.title}>
                <div className={style.author}>
                    {author}
                    {isSigned && <div className={style.signedIcon}>{FixedIcon.getSignedIcon()}</div>}
                </div>
                <div className={style.versionDate}>
                    {DateHelper.format(new Date(updateTime), DateFormat.DateWithTime)}
                </div>
            </div>
            {isHtml ? (
                <div
                    className={style.fieldValue}
                    dangerouslySetInnerHTML={{ __html: value }}
                />
            ) : (
                <div className={style.fieldValue}>{value}</div>
            )}
            {/*<div*/}
            {/*    className={style.restoreButton}*/}
            {/*    onClick={onRestoreClick}*/}
            {/*>*/}
            {/*    Востановить*/}
            {/*</div>*/}
        </div>
    );
}
